var REQUEST = 'REQUEST';
var SUCCESS = 'SUCCESS';
var FAILURE = 'FAILURE';
function createRequestTypes(base) {
    var res = {};
    [REQUEST, SUCCESS, FAILURE].forEach(function (type) { return res[type] = "".concat(base, "_").concat(type); });
    return res;
}
function action(type, data, section) {
    if (data === void 0) { data = {}; }
    if (section === void 0) { section = undefined; }
    return {
        type: type,
        data: data,
        section: section
    };
}
export var LIVE_INIT = createRequestTypes('LIVE_INIT');
export var LIVE_UPDATE = createRequestTypes('LIVE_UPDATE');
export var LIVE_UPDATE_BETSLIPS = createRequestTypes('LIVE_UPDATE_BETSLIPS');
export var LIVE_MATCH_INIT = createRequestTypes('LIVE_MATCH_INIT');
export var LIVE_MATCH_UPDATE = createRequestTypes('LIVE_MATCH_UPDATE');
export var GET_BALANCE = createRequestTypes('GET_BALANCE');
export var TIMETABLE_INIT = createRequestTypes('TIMETABLE_INIT');
export var TIMETABLE_UPDATE = createRequestTypes('TIMETABLE_UPDATE');
export var GET_POPULAR_LIVE = createRequestTypes('GET_POPULAR_LIVE');
export var GET_BET_STATUS = createRequestTypes('GET_BET_STATUS');
export var GET_MULTI_BET_STATUS = createRequestTypes('GET_MULTI_BET_STATUS');
export var GET_QUICKBET_STATUS = createRequestTypes('GET_QUICKBET_STATUS');
export var GET_FREEBET = createRequestTypes('GET_FREEBET');
export var sagaActions = {
    live_initial: {
        request: function (data) { return action(LIVE_INIT.REQUEST, { languageId: data.languageId }, 'live'); },
        success: function (data) { return action(LIVE_INIT.SUCCESS, data, 'live'); },
        failure: function (data, error) { return action(LIVE_INIT.FAILURE, { languageId: data.languageId, error: error }, 'live'); }
    },
    live_update: {
        request: function (data) { return action(LIVE_UPDATE.REQUEST, { languageId: data.languageId, version: data.version }, 'live'); },
        success: function (data) { return action(LIVE_UPDATE.SUCCESS, data, 'live'); },
        failure: function (data, error) { return action(LIVE_UPDATE.FAILURE, { languageId: data.languageId, version: data.version, error: error }, 'live'); }
    },
    live_update_betslips: {
        request: function (data) { return action(LIVE_UPDATE_BETSLIPS.REQUEST, { languageId: data.languageId, version: data.version }, 'liveBetslips'); },
        success: function (data) { return action(LIVE_UPDATE_BETSLIPS.SUCCESS, data, 'liveBetslips'); },
        failure: function (data, error) { return action(LIVE_UPDATE_BETSLIPS.FAILURE, { languageId: data.languageId, version: data.version, error: error }, 'liveBetslips'); }
    },
    live_initial_match: {
        request: function (data) { return action(LIVE_MATCH_INIT.REQUEST, { languageId: data.languageId }, 'liveMatch'); },
        success: function (data) { return action(LIVE_MATCH_INIT.SUCCESS, data, 'liveMatch'); },
        failure: function (data, error) { return action(LIVE_MATCH_INIT.FAILURE, { languageId: data.languageId, error: error }, 'liveMatch'); }
    },
    live_update_match: {
        request: function (data) { return action(LIVE_MATCH_UPDATE.REQUEST, { languageId: data.languageId, version: data.version }, 'liveMatch'); },
        success: function (data) { return action(LIVE_MATCH_UPDATE.SUCCESS, data, 'liveMatch'); },
        failure: function (data, error) { return action(LIVE_MATCH_UPDATE.FAILURE, { languageId: data.languageId, version: data.version, error: error }, 'liveMatch'); }
    },
    get_popular_live: {
        request: function () { return action(GET_POPULAR_LIVE.REQUEST); },
        success: function (data) { return action(GET_POPULAR_LIVE.SUCCESS, data); },
        failure: function (data, error) { return action(GET_POPULAR_LIVE.FAILURE, error); }
    },
    get_balance: {
        request: function (data) { return action(GET_BALANCE.REQUEST, data); },
        success: function (data) { return action(GET_BALANCE.SUCCESS, data); },
        failure: function (data, error) { return action(GET_BALANCE.FAILURE, error); }
    },
    timetable_initial: {
        request: function (data) { return action(TIMETABLE_INIT.REQUEST, { languageId: data.languageId }, 'timetable'); },
        success: function (data) { return action(TIMETABLE_INIT.SUCCESS, data, 'timetable'); },
        failure: function (data, error) { return action(TIMETABLE_INIT.FAILURE, { languageId: data.languageId, error: error }, 'timetable'); }
    },
    timetable_update: {
        request: function (data) { return action(TIMETABLE_UPDATE.REQUEST, { languageId: data.languageId, version: data.version }, 'timetable'); },
        success: function (data) { return action(TIMETABLE_UPDATE.SUCCESS, data, 'timetable'); },
        failure: function (data, error) { return action(TIMETABLE_UPDATE.FAILURE, { languageId: data.languageId, version: data.version, error: error }, 'timetable'); }
    },
    get_bet_status: {
        request: function (data) { return action(GET_BET_STATUS.REQUEST, data); },
        success: function (data) { return action(GET_BET_STATUS.SUCCESS, data); },
        failure: function (data, error) { return action(GET_BET_STATUS.FAILURE, data); }
    },
    get_multi_bet_status: {
        request: function (data) { return action(GET_MULTI_BET_STATUS.REQUEST, data); },
        success: function (data) { return action(GET_MULTI_BET_STATUS.SUCCESS, data); },
        failure: function (data, error) { return action(GET_MULTI_BET_STATUS.FAILURE, data); }
    },
    get_quickbet_status: {
        request: function (data) { return action(GET_QUICKBET_STATUS.REQUEST, data); },
        success: function (data) { return action(GET_QUICKBET_STATUS.SUCCESS, data); },
        failure: function (data, error) { return action(GET_QUICKBET_STATUS.FAILURE, data); }
    },
    get_freebet: {
        request: function (data) { return action(GET_FREEBET.REQUEST); },
        success: function (data) { return action(GET_FREEBET.SUCCESS, data); },
        failure: function (data, error) { return action(GET_FREEBET.FAILURE); }
    },
};



// WEBPACK FOOTER //
// ./src/sagas/actions.js